<template>

  <div>
    <xolas-table
    table-ref="rentalsummarytable"

    title="Rentals/Lease"
    icon="fa fa-hand-holding-usd"

    search-placeholder="Site name, Landlord"

    url="/report/property/rentals/summary"
    :fields="fields" />

</div>
</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [DateMixins, NumberMixins],

  data () {
    return {
      stats: this.getStats(),
      fields: [
        {
          name: '__sequence',
          title: '#',
          width: 36
        },
        {
          name: 'landStatus',
          title: 'Status',
          minWidth: 44,
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-primary'
        },
        {
          name: 'landType',
          title: 'Land Type',
          minWidth: 70,
          titleClass: 'hidden-md-and-down text-warning',
          dataClass: 'hidden-md-and-down text-warning'
        },
        {
          name: 'name',
          title: 'Landlord',
          minWidth: 362
        },
        {
          name: 'siteName',
          title: 'Site Name',
          minWidth: 205
        },
        {
          name: 'deposit',
          title: 'Deposit',
          minWidth: 93,
          callback: this.formatMoney,
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-success'
        },
        {
          name: 'depositMonths',
          title: 'Dep. Mths',
          minWidth: 68,
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-success'
        },
        {
          name: 'lastRenewalDate',
          title: 'Last Renewal',
          minWidth: 92,
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'renewals',
          title: 'Renewals',
          minWidth: 66,
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-primary'
        },
        {
          name: 'nextPaymentDate',
          title: 'Date Due',
          minWidth: 78,
          callback: this.formatDate,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right'
        },
        {
          name: 'nextPayment',
          title: 'Due',
          minWidth: 93,
          callback: this.formatMoney,
          titleClass: 'hidden-sm-and-down text-danger',
          dataClass: 'hidden-sm-and-down text-danger text-right'
        }
      ]
    }
  }
}
</script>

<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
/* Match the legacy vuetable ~41px row height (el-table's default line-height
   made rows ~48px). */
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
